import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { Row, Col } from 'react-bootstrap';
import moment from 'moment';
import WorkshopSteps from './workshop/Steps';
import WorkshopSessions from './workshop/Sessions';
import Child from './Child';
import Confirm from './Confirm';
import { updateSelectedCenter } from '../actions';
import { fetchPayment, PaymentTypes, PAYMENT_FETCH_REQUEST, PAYMENT_FETCH_SUCCESS, PAYMENT_FETCH_FAILURE } from '../payments/actions';
import { getChild, hasSameAsParentChild } from '../reducer';
import {
	loadPaymentMethods, loadInstalmentPlans, createAndSelectChild,
	selectChild, selectWorkshopSessions, selectPaymentType, selectPaymentMethod,
	saveWorkshopBooking, initiatePayment, resetBooking,
	applyPromoCode, removePromoCode,
	PAYMENT_START_REQUEST, PAYMENT_START_SUCCESS, PAYMENT_START_FAILURE,
	PAYMENT_CANCEL_SUCCESS,
	WORKSHOP_BOOKING_CREATE_REQUEST, WORKSHOP_BOOKING_CREATE_SUCCESS, WORKSHOP_BOOKING_CREATE_FAILURE,
	APPLY_PROMO_CODE_REQUEST, APPLY_PROMO_CODE_SUCCESS, APPLY_PROMO_CODE_FAILURE,
	REMOVE_PROMO_CODE_REQUEST, REMOVE_PROMO_CODE_SUCCESS, REMOVE_PROMO_CODE_FAILURE
} from './actions';
import { fetchMedicalInformation, updateMedicalInformation } from '../children/actions';
import {
	fetchWorkshop, loadWorkshopSessions, WORKSHOP_SESSIONS_REQUEST, WORKSHOP_SESSIONS_SUCCESS, WORKSHOP_SESSIONS_FAILURE
} from '../common/actions';
import { initPaymentMethod } from './paymentMethods/actions';
import queryString from 'query-string';
import { withNamespaces } from 'react-i18next';
import analyticsTracker from '../../common/services/analyticsTracker';
import { getFormValues, change, clearSubmitErrors } from 'redux-form';
import { getActiveLanguage } from '../../languages/reducer';

class WorkshopBooking extends Component {
	constructor(props) {
		super(props);
		this.handleClassNavigateBack = this.handleClassNavigateBack.bind(this);
		this.handleChildSettingsSubmit = this.handleChildSettingsSubmit.bind(this);
		this.handleUpdateChildMedicalInformation = this.handleUpdateChildMedicalInformation.bind(this);
		this.handleChildSelect = this.handleChildSelect.bind(this);
		this.handleNewChildSelect = this.handleNewChildSelect.bind(this);
		this.handlePaymentTypeSelect = this.handlePaymentTypeSelect.bind(this);
		this.handleSessionsSelect = this.handleSessionsSelect.bind(this);
		this.handleConfirmBooking = this.handleConfirmBooking.bind(this);
		this.handleApplyPromoCode = this.handleApplyPromoCode.bind(this);
		this.handleRemovePromoCode = this.handleRemovePromoCode.bind(this);
		this.handleSelectPaymentMethod = this.handleSelectPaymentMethod.bind(this);
		this.steps = [
			{
				id: 2,
				name: 'child',
				render: () => {
					const { queryParams: { add, medical, reset }, franchisor, requireMedicalInformation, bookingOptions: { selectedChildId } } = this.props;
					const isAdd = add === 'true';
					const isMedical = medical === 'true';
					const isReset = reset === 'true';

					if (selectedChildId > 0 && !requireMedicalInformation && !isAdd) {
						return <Redirect to='./class' />;
					}

					if (selectedChildId > 0 && requireMedicalInformation && !isMedical && !isReset) {
						return <Redirect to='./child?medical=true' />;
					}

					return <Child mode={isMedical ? 'medicalInfo' : isAdd ? 'add' : 'select'}
						children={this.props.parent.children}
						selectedChild={selectedChildId > 0 ? getChild(this.props.parent, selectedChildId) : null}
						onSelectChild={this.handleChildSelect} onSelectNewChild={this.handleNewChildSelect}
						onAddChild={this.handleChildSettingsSubmit} genderTypes={this.props.genderTypes}
						requireChildLastName={franchisor.requireChildLastName}
						requireChildSchool={franchisor.requireChildSchool}
						enableParentSelfBooking={franchisor.enableParentSelfBooking}
						hasSameAsParentChild={hasSameAsParentChild(this.props.parent)}
						medicalInformation={this.props.medicalInformation}
						currentMedicalInfoFormValues={this.props.currentMedicalInfoFormValues}
						changeMedicalInfoFormValue={this.props.changeMedicalInfoFormValue}
						clearMedicalInfoFormErrors={this.props.clearMedicalInfoFormErrors}
						onUpdateMedicalInformation={this.handleUpdateChildMedicalInformation}
					/>;
				}
			},
			{
				id: 3,
				name: 'class',
				render: () => {
					if (!this.props.bookingOptions.selectedChildId) {
						return <Redirect to='./child' />;
					}

					return <WorkshopSessions
						workshop={this.props.workshop}
						workshopSessions={this.props.workshopSessions}
						currentUser={this.props.currentUser}
						bookingOptions={this.props.bookingOptions}
						onSelectSessions={this.handleSessionsSelect}
						onNavigateBack={this.handleClassNavigateBack}
						enableUserTimeZone={this.props.enableUserTimeZone}
						limitToShowLeftWorkshopSpots={this.props.franchisor.limitToShowLeftWorkshopSpots}
						center={this.props.selectedCenter}
						block={[WORKSHOP_BOOKING_CREATE_REQUEST]}
						unblock={[WORKSHOP_BOOKING_CREATE_FAILURE]}
					/>;
				}
			},
			{
				id: 4,
				name: 'confirm',
				render: () => {
					return <Confirm
						paymentMethods={this.props.bookingOptions.paymentMethods}
						paymentProcessors={this.props.paymentProcessors}
						instalmentPlans={this.props.bookingOptions.instalmentPlans}
						payment={this.props.payment}
						paymentType={PaymentTypes.Workshop}
						requireConsentOnPayment={this.props.franchisor.requireConsentOnPayment}
						termsAndConditions={this.props.franchisor.termsAndConditions}
						onPaymentMethodInit={this.props.initPaymentMethod}
						onSelectPaymentMethod={this.handleSelectPaymentMethod}
						onApplyPromoCode={this.handleApplyPromoCode}
						onRemovePromoCode={this.handleRemovePromoCode}
						promoCodeErrorMessage={this.props.promoCodeErrorMessage}
						enableUserTimeZone={this.props.franchisor.enableUserTimeZone}
						enableCurrencyConversion={this.props.franchisor.enableCurrencyConversion}
						currentCurrency={this.props.currentCurrency}
						franchisorCurrency={this.props.franchisor.currency}
						countryCode={this.props.franchisor.countryCode}
						onConfirm={this.handleConfirmBooking}
						errorMessage={this.props.paymentErrorMessage}
						cancellationReason={this.props.cancellationReason}
						block={[PAYMENT_START_REQUEST, APPLY_PROMO_CODE_REQUEST, REMOVE_PROMO_CODE_REQUEST, PAYMENT_FETCH_REQUEST]}
						unblock={[APPLY_PROMO_CODE_SUCCESS, APPLY_PROMO_CODE_FAILURE, REMOVE_PROMO_CODE_SUCCESS, REMOVE_PROMO_CODE_FAILURE,
							PAYMENT_FETCH_SUCCESS, PAYMENT_FETCH_FAILURE, PAYMENT_CANCEL_SUCCESS]} // do not unblock UI once payment is started, just wait for redirection to next page
					/>;
				}
			}];
	}

	componentDidMount() {
		const {
			match,
			history,
			fetchPayment,
			loadInstalmentPlans,
			selectedCenterId,
			fetchWorkshop,
			loadWorkshopSessions,
			loadPaymentMethods,
			updateSelectedCenter,
			bookingOptions: { selectedChildId, workshopId },
			queryParams: { reset },
			resetBooking
		} = this.props;

		if (reset === 'true') {
			resetBooking();
		}

		if (match.params.step === 'class' && !selectedChildId) {
			history.replace('child');
		}

		if (match.params.step === 'confirm') {
			const paymentId = Number(match.params.id);
			fetchPayment(paymentId, PaymentTypes.Workshop);
			loadInstalmentPlans(paymentId);
		}

		if (selectedCenterId && workshopId) {
			fetchWorkshop(selectedCenterId, workshopId);
			loadWorkshopSessions(selectedCenterId, workshopId);
			loadPaymentMethods(selectedCenterId);
			updateSelectedCenter(selectedCenterId, this.props.history, false);
		}
	}

	componentWillReceiveProps(nextProps) {
		if (!this.props.bookingOptions.selectedChildId && nextProps.bookingOptions.selectedChildId && nextProps.requireMedicalInformation) {
			this.props.fetchMedicalInformation(nextProps.bookingOptions.selectedChildId);
		}

		if (this.props.match.params.step !== 'confirm' && nextProps.match.params.step === 'confirm') {
			const paymentId = nextProps.match.params.id;
			this.props.fetchPayment(paymentId, PaymentTypes.Workshop);
			this.props.loadInstalmentPlans(paymentId);
		}

		if (this.props.queryParams.reset !== 'true' && nextProps.queryParams.reset === 'true') {
			this.props.resetBooking();
		}
	}

	handleChildSettingsSubmit(values) {
		this.props.createAndSelectChild(values, this.props.history);
	}

	handleUpdateChildMedicalInformation(values) {
		const { selectedChildId } = this.props.bookingOptions;
		if (selectedChildId > 0) {
			this.props.updateMedicalInformation(selectedChildId, values);
		}
	}

	handleClassNavigateBack() {
		this.props.history.push(`/public/workshops/${this.props.selectedCenterId}/${this.props.bookingOptions.workshopId}`);
	}

	handleChildSelect(child) {
		this.props.selectChild(child.id);
		this.props.history.push('child');	// removes reset=true
	}

	handleNewChildSelect() {
		this.props.history.push('child?add=true');
	}

	handlePaymentTypeSelect({ paymentTypeId, isPrepaid, isBonusLesson }) {
		this.props.selectPaymentType({ paymentTypeId, isPrepaid, isBonusLesson });
	}

	handleSessionsSelect(sessionIds) {
		const {
			franchisor,
			bookingOptions: { workshopId, selectedChildId, selectedPaymentMethodName }
		} = this.props;

		const campaignTags = analyticsTracker.getCampaignTags(franchisor);

		const bookingRequestData = {
			childId: selectedChildId,
			workshopId,
			sessionIds,
			paymentMethodName: selectedPaymentMethodName,
			campaignTags
		};

		// update selected sessions in state in case user selects Back on Confirm page
		this.props.selectWorkshopSessions(sessionIds);

		// save booking and go to Confirm
		this.props.saveWorkshopBooking(bookingRequestData, this.props.history);
	}

	handleApplyPromoCode(promoCode) {
		if (this.props.payment) {
			this.props.applyPromoCode({ paymentId: this.props.payment.id, promoCode, paymentType: PaymentTypes.Workshop });
		}
	}

	handleRemovePromoCode(promoCode) {
		if (this.props.payment) {
			this.props.removePromoCode({ paymentId: this.props.payment.id, promoCode, paymentType: PaymentTypes.Workshop });
		}
	}

	handleSelectPaymentMethod(paymentMethod, isInstalmentPayment, instalmentPlanTemplateId) {
		if (this.props.payment) {
			this.props.selectPaymentMethod({ paymentId: this.props.payment.id, paymentMethod, paymentType: PaymentTypes.Workshop, isInstalmentPayment, instalmentPlanTemplateId });
		}
	}

	handleConfirmBooking({ paymentMethod }) {
		if (this.props.payment) {
			this.props.initiatePayment({ paymentId: this.props.payment.id, paymentMethod }, this.props.history);
		}
	}

	render() {
		const { match } = this.props;
		const currentStepName = match.params.step;
		let currentStep = currentStepName && this.steps.find(s => s.name === currentStepName);
		if (!currentStep) {
			currentStep = this.steps[0];
		}

		return (
			<div>
				<WorkshopSteps currentStep={currentStep.id} />
				<Row>
					<Col sm={12}>
						{currentStep.render()}
					</Col>
				</Row>
			</div>
		);
	}
}

const mapStateToProps = (state, ownProps) => {
	const {
		parent,
		entities: { centers, workshops, workshopSessions, payments, medicalInformations },
		lookups: { medicalInformationForm },
		configuration: { franchisor },
		auth: { currentUser },
		paymentProcessors
	} = state;

	const {
		availability,
		selectedChildId,
		selectedWorkshopSessionIds,
		selectedPaymentTypeId,
		selectedPaymentMethodName,
		workshopErrorMessage,
		paymentMethodsByCenter,
		instalmentPlans,
		promoCodeErrorMessage,
		cancellationReason,
		result
	} = state.booking;

	const queryParams = queryString.parse(ownProps.location.search);
	const workshopId = Number(ownProps.match.params.workshopId);
	const centerId = Number(ownProps.match.params.centerId);

	const workshopSessionsFilter = state.filters.workshopSessions[workshopId] || { ids: [] };

	const paymentId = ownProps.match.params.step === 'confirm' && Number(ownProps.match.params.id);
	const savedPayment = paymentId && payments[paymentId];
	if (savedPayment) {
		savedPayment.parent = parent;
		savedPayment.child = getChild(parent, savedPayment.childId);
		if (savedPayment.centerId) {
			savedPayment.center = centers[savedPayment.centerId];
		}
		if (savedPayment.workshopId) {
			savedPayment.workshop = workshops[savedPayment.workshopId];
		}
		if (savedPayment.workshopSessionIds) {
			savedPayment.workshopSessions = savedPayment.workshopSessionIds.map(sessionId => workshopSessions[sessionId] || { start: null, end: null });
		}
	}

	const requireMedicalInformation = selectedChildId && franchisor.requireMedicalInformation && !medicalInformations[selectedChildId];
	const medicalInformation = medicalInformations[selectedChildId] || (medicalInformationForm && {
		id: 0,
		formId: medicalInformationForm.id,
		childId: selectedChildId,
		name: medicalInformationForm.name,
		content: {}
	});

	const selectedCenter = centers[centerId];
	const now = new Date();
	const activeLanguage = getActiveLanguage(state.configuration.language);

	return {
		franchisor,
		parent,
		workshop: workshops[workshopId],
		workshopSessions: workshopSessionsFilter.ids.map(id => {
			const session = workshopSessions[id];
			return session && {
				...session,
				upcoming: selectedCenter ? moment(session.start).utcOffset(selectedCenter.utcOffset, true) > now : false		// actual start time using center's timezone
			};
		}),
		selectedCenterId: centerId,
		selectedCenter,
		cities: [...new Set(Object.values(centers).map(center => center.city))],	// distinct list of cities with centers
		centers: Object.values(centers),
		bookingOptions: {
			workshopId,
			availability,
			selectedChildId,
			selectedWorkshopSessionIds,
			selectedPaymentTypeId,
			selectedPaymentMethodName,
			errorMessage: workshopErrorMessage,
			paymentMethods: paymentMethodsByCenter[centerId] ? paymentMethodsByCenter[centerId] : [],
			instalmentPlans
		},
		paymentProcessors,
		payment: savedPayment,
		cancellationReason,
		promoCodeErrorMessage,
		paymentErrorMessage: result && result.errorMessage,
		queryParams,
		currentUser,
		requireMedicalInformation,
		medicalInformation,
		currentMedicalInfoFormValues: getFormValues('customForm')(state),
		enableUserTimeZone: franchisor.enableUserTimeZone,
		currentCurrency: activeLanguage && activeLanguage.currencyCode
	};
};

export default connect(mapStateToProps, {
	updateSelectedCenter,
	fetchWorkshop,
	loadWorkshopSessions,
	loadPaymentMethods,
	loadInstalmentPlans,
	createAndSelectChild,
	selectChild,
	selectWorkshopSessions,
	selectPaymentType,
	selectPaymentMethod,
	saveWorkshopBooking,
	fetchPayment,
	initPaymentMethod,
	initiatePayment,
	resetBooking,
	applyPromoCode,
	removePromoCode,
	fetchMedicalInformation,
	updateMedicalInformation,
	changeMedicalInfoFormValue: (field, value) => change('customForm', field, value),
	clearMedicalInfoFormErrors: () => clearSubmitErrors('customForm')
})(withNamespaces()(WorkshopBooking));